import { Component } from '@angular/core';

@Component({ standalone: false, 
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent {
  public hideFilterPane(): void {
    const filterSide = document.querySelector(`#dashboard main`);
    filterSide.classList.add('is-showing-filters');
  }
}
